import { useState, useSyncExternalStore } from "react";
import { setSoundVolume, soundVolume, subscribeSound, unlockSound } from "../../lib/sound.js";
import { GameIcon } from "./GameIcon.js";
import {
  graphicsQuality,
  setGraphicsQuality,
  subscribeGraphics,
  type GraphicsQuality,
} from "../../lib/graphics.js";

export function SoundControl(): JSX.Element {
  const volume = useSyncExternalStore(subscribeSound, soundVolume);
  const quality = useSyncExternalStore(subscribeGraphics, graphicsQuality);
  const [open, setOpen] = useState(false);
  return (
    <div className="relative flex items-center">
      <button
        type="button"
        aria-label={volume ? "Mute sound" : "Enable sound"}
        aria-pressed={volume === 0}
        className="flex h-11 w-11 items-center justify-center rounded-lg text-gold hover:bg-panel"
        onClick={() => {
          unlockSound();
          setSoundVolume(volume ? 0 : 0.3);
        }}
      >
        <GameIcon name={volume ? "sound" : "muted"} size={18} />
      </button>
      <button
        type="button"
        aria-label="Sound and graphics settings"
        aria-expanded={open}
        className="h-11 w-11 rounded-lg text-xs text-ink-dim hover:bg-panel"
        onClick={() => setOpen(!open)}
      >
        ⌄
      </button>
      {open ? (
        <div className="absolute right-0 top-full z-50 w-56 rounded-xl border border-panel-edge bg-bg-raised p-3 shadow-panel">
          <label className="flex flex-col gap-2 text-xs text-ink">
            Sound · {Math.round(volume * 100)}%
            <input
              aria-label="Sound volume level"
              type="range"
              min="0"
              max="100"
              value={Math.round(volume * 100)}
              onChange={(e) => {
                unlockSound();
                setSoundVolume(Number(e.target.value) / 100);
              }}
            />
          </label>
          <label className="mt-4 flex flex-col gap-2 text-xs text-ink">
            Graphics
            <select
              aria-label="Graphics"
              className="h-11 rounded-lg border border-panel-edge bg-panel px-2"
              value={quality}
              onChange={(e) => setGraphicsQuality(e.target.value as GraphicsQuality)}
            >
              <option value="balanced">Smooth · 60 fps</option>
              <option value="battery">Save battery · 30 fps</option>
            </select>
          </label>
          <button
            type="button"
            className="mt-2 h-11 w-full text-xs text-gold"
            onClick={() => setOpen(false)}
          >
            Done
          </button>
        </div>
      ) : null}
    </div>
  );
}
